// extracted by mini-css-extract-plugin
export default {"areaFestival":"index_areaFestival_wt9aF","navBar":"index_navBar_IMopj","header":"index_header_2zdVU","areaReports":"index_areaReports_jb4f7","blank50":"index_blank50_plBz-"};